import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import authReducer from "../admin/redux/reducers/authReducer";
import oemReducer from "../admin/redux/reducers/oemReducer";
import almataReducer from "../admin/redux/reducers/almataReducer";
import countryReducer from "../admin/redux/reducers/countryReducer";
import planReducer from "../admin/redux/reducers/planReducer";
import scanReducer from "../admin/redux/reducers/scanReducer";
import transactionReducer from "../admin/redux/reducers/transactionReducer";
import couponReducer from "../admin/redux/reducers/couponReducer";
import revenueReducer from "../admin/redux/reducers/revenueReducer";
import dashboardReducer from "../admin/redux/reducers/dashboard/dashboardReducer";
import profileReducer from "../admin/redux/reducers/profileReducer";
import emailVerificationReducer from "../admin/redux/reducers/emailVerificationReducer";

import uiSlice from "./slices/uiSlice";
import themeSlice from "./slices/themeSlice";
import userSlice from "./slices/userSlice";
import rootSaga from "../admin/redux/sagas/rootSaga";
import itSalesReducer from "../admin/redux/reducers/itSalesReducer";
import settingReducer from "../admin/redux/reducers/settingReducer";
const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    user: userSlice,
    ui: uiSlice,
    theme: themeSlice,
    auth: authReducer,
    oem: oemReducer,
    almata: almataReducer,
    country: countryReducer,
    plan: planReducer,
    scan: scanReducer,
    transaction: transactionReducer,
    coupon: couponReducer,
    revenue: revenueReducer,
    dashboard: dashboardReducer,
    profile: profileReducer,
    itSales: itSalesReducer,
    emailVerification: emailVerificationReducer,
    setting: settingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
        warnAfter: 128,
      },
      immutableCheck: {
        warnAfter: 128,
      },
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;
